import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function AlterarSenhaPage() {
  const { user, changePassword } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('A nova senha deve ter pelo menos 6 caracteres.');
      return;
    }

    if (password !== confirmPassword) {
      setError('As senhas não conferem.');
      return;
    }

    setSubmitting(true);
    const result = await changePassword(password);
    setSubmitting(false);

    if (!result.success) {
      setError(result.error || 'Erro ao alterar senha.');
      return;
    }

    navigate(user?.perfil === 'admin' ?'/admin/dashboard' : '/colaborador', { replace: true });
  };

  return (
    <div className="max-w-xl mx-auto">
      <div className="bg-white rounded-xl border border-portal-gray-200 p-6 md:p-8">
        <div className="w-12 h-12 rounded-full bg-portal-purple-50 flex items-center justify-center mb-4">
          <i className="ri-lock-password-line text-portal-purple text-xl"></i>
        </div>
        <h1 className="text-xl font-bold text-portal-gray-900 mb-2">Altere sua senha</h1>
        <p className="text-sm text-portal-gray-500 mb-6">
          Para continuar usando o portal, cadastre uma senha pessoal.
        </p>

        {error && (
          <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-portal-gray-700 mb-1.5">
              Nova senha
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="w-full px-3.5 py-2.5 border border-portal-gray-300 rounded-lg text-sm text-portal-gray-800 focus:outline-none focus:ring-2 focus:ring-portal-purple/20 focus:border-portal-purple"
              autoComplete="new-password"
              required
            />
          </div>

          <div>
            <label htmlFor="confirmPassword" className="block text-sm font-medium text-portal-gray-700 mb-1.5">
              Confirmar senha
            </label>
            <input
              id="confirmPassword"
              type="password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              className="w-full px-3.5 py-2.5 border border-portal-gray-300 rounded-lg text-sm text-portal-gray-800 focus:outline-none focus:ring-2 focus:ring-portal-purple/20 focus:border-portal-purple"
              autoComplete="new-password"
              required
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-portal-purple hover:bg-portal-purple-dark text-white font-medium py-2.5 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {submitting ?'Salvando...' : 'Salvar nova senha'}
          </button>
        </form>
      </div>
    </div>
  );
}
